<template>
  <div
    class="info-report-card pt-1 px-1 m-0 text-center"
    :class="blockClasses"
  >
    <div
      class="info-report-card__value"
      :style="{ 'font-size': fontSizeByCharacters }"
    >
      {{ value }}
    </div>
    <div
      class="info-report-card__description"
    >
      {{ description }}
    </div>
  </div>
</template>

<script>

export default {
  props: {
    value: {
      type: String,
      default: '',
    },
    description: {
      type: String,
    },
    acceptable: {
      type: Boolean,
      default: true,
    },
  },
  computed: {
    fontSizeByCharacters() {
      if (this.value === '') {
        return '2.2em';
      }
      let result = '';
      if (this.value.length >= 12) {
        result = '1.4em';
      } else if (this.value.length >= 9) {
        result = '1.6em';
      } else {
        result = '2.2em';
      }

      return result;
    },

    blockClasses() {
      return {
        'info-report-card_unacceptable': !this.acceptable,
      };
    },
  },
};
</script>

<style lang="sass" scoped>
@import "src/styles/defaults/variables"
@import "src/styles/defaults/mobile-first"

.info-report-card
  border-style: solid
  border-width: 1px
  border-radius: 5px
  border-color: var(--color-success)
  min-height: 9em
  width: 17em
  padding: .2em
  +media-min-sm()
    width: 11em
  &__value
    margin-top: .2em
    font-size: 2.2em
    font-weight: 500
    line-height: 1.1em
    min-height: 1.5em
    vertical-align: middle
    word-break: break-word
    padding-bottom: .5em
  &__description
    text-align: center
    font-size: .75em
    line-height: 1.2em
    font-weight: bold
  &_unacceptable
    border-color: var(--color-danger)
    .info-report-card
      &__value
        color: var(--color-danger)
      &__description
        color: var(--color-danger)
</style>
